/**
 * Created by hiral on 2/11/17.
 */

import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { BaseFilterCellComponent, FilterService } from '@progress/kendo-angular-grid';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-kendo-string-filter',
  template: `
    <div class="k-filtercell-wrapper">
      <input type="text" class="k-textbox" [id]="field" [attr.aria-label]="ariaLabel || 'Filter by ' + field" [(ngModel)]="value" (keyup.enter)="callFilter($event)"/>
    </div>
  `
})
export class KendoStringFilterComponent extends BaseFilterCellComponent implements OnInit, OnChanges {
    // in the template
   // <div class="k-filtercell-wrapper">
    //   <label [for]="field" class="sr-only">{{ariaLabel || 'Filter by ' + field}}</label>
    //   <input type="text" class="k-textbox" [id]="field" [attr.aria-label]="ariaLabel" [attr.title]="ariaLabel || 'Filter by ' + field" [(ngModel)]="value" (keyup.enter)="callFilter($event)"/>
    // </div>
  @Input() public filter: any;
  @Input() public sort: any;
  @Input() public data: any[];
  @Input() public field: string;
  @Input() public column: any;
  @Input() clearInputValue: Subject<any>;
  @Input('aria-label') ariaLabel: string;
  @Input() title: string;
  public value: string;


  constructor(filterService: FilterService) {
    super(filterService);
  }

  ngOnInit(): void {
    const filter = this.filterByField(this.field);
    if (filter && filter.value !== undefined && filter.value !== null) {
      this.value = filter.value;
    }
    if (this.clearInputValue) {
      this.clearInputValue.subscribe(event => {
        this.resetFilter();
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filter']) {
      const filter = this.filterByField(this.field);
      const filterValue = (filter && filter.value !== undefined && filter.value !== null) ? filter.value : '';
      if (this.value !== filterValue) {
        this.value = filterValue;
      }
    }
  }

  public callFilter(event: any): void {
    const givenString = this.value;
    if (givenString !== undefined && givenString !== null && givenString !== '') {
      this.applyFilter(
        this.updateFilter({
          field: this.field,
          operator: 'contains',
          value: givenString
        })
      );
    }
  }

  public resetFilter(): any {
    this.value = '';
    this.applyFilter(
      this.removeFilter(this.field)
    );
  }
}
